import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

import { toggleSliderOverlay } from '../functions.js';

Swiper.use([Pagination, Navigation]);

const swiperNavNextSelector = '.swiper-button-next';
const swiperNavPrevSelector = '.swiper-button-prev';
const swiperPaginationSelector = '.swiper-pagination';

const swiperConfig = {
    slidesPerView: 1,
    breakpoints: {
        768: {
            slidesPerView: 2,
        },
        1024: {
            slidesPerView: 3,
        },
    },
    spaceBetween: 32,
    navigation: {
        nextEl: swiperNavNextSelector,
        prevEl: swiperNavPrevSelector,
    },
    pagination: {
        el: swiperPaginationSelector,
        clickable: true
    },
}

document.addEventListener('DOMContentLoaded', () => {
    const $popupSliders = document.querySelectorAll('.popup-slider');

    $popupSliders.forEach($slider => {
        let swiper = new Swiper($slider, {
            ...swiperConfig,
            spaceBetween: 0,
            on: {
                init: swiper => {
                    updateNavigationButtons(swiper);
                },
                slideChange: swiper => {
                    updateNavigationButtons(swiper);
                },
            },
        });

        let $deleteButton = $slider.querySelector('.delete');
        swiper.slides.length > 2 ? $deleteButton.classList.add('is-hidden') : $deleteButton.addEventListener('click', resetSlider);

        function updateNavigationButtons(swiper) {
            [swiper.navigation.prevEl, swiper.navigation.nextEl].forEach($el => {
                $el.removeEventListener('click', toggleSliderOverlay);
                $el.removeEventListener('click', resetSlider);

                if ($el.disabled) {
                    $el.disabled = false;
                    $el.classList.remove('swiper-button-disabled');
                    $el.classList.remove('swiper-button-lock');
                    $el.classList.add('slider-overlay-trigger');
                    $el.addEventListener('click', toggleSliderOverlay);
                    $el.addEventListener('click', resetSlider);
                }
            });
        }

        function resetSlider() {
            swiper.slideTo(0);
        }
    });

    const $heroSliders = document.querySelectorAll('.hero-slider');

    $heroSliders.forEach($slider => {
        let swiper = new Swiper($slider, {
            ...swiperConfig,
            spaceBetween: 0,
            breakpoints: null,
        });
    });

    const $gallerySliders = document.querySelectorAll('.widget-gallery-slider');

    $gallerySliders.forEach($slider => {
        let next = $slider.parentNode.querySelector(swiperNavNextSelector);
        let prev = $slider.parentNode.querySelector(swiperNavPrevSelector);
        let pagination = $slider.parentNode.querySelector(swiperPaginationSelector);
        let loopFullscreen = parseInt($slider.dataset.count) > 3;
        new Swiper($slider, {
            ...swiperConfig,
            slidesPerView: 1.2,
            loop: true,
            breakpoints: {
                768: {
                    slidesPerView: 2.2
                },
                1024: {
                    slidesPerView: 3.3
                },
                1504: {
                    slidesPerView: 3.7,
                    loop: loopFullscreen
                },
            },
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            pagination: {
                el: pagination,
                clickable: true
            }
        });
    });

    const $discoverSliders = document.querySelectorAll('.widget-discover-slider');

    $discoverSliders.forEach($slider => {
        new Swiper($slider, {
            ...swiperConfig,
            breakpoints: null,
        });
    });

    const $quoteSliders = document.querySelectorAll('.widget-quote-slider');

    $quoteSliders.forEach($slider => {
        new Swiper($slider, {
            ...swiperConfig,
            breakpoints: {
                1024: {
                    slidesPerView: 2,
                },
            },
        });
    });

    const $imageCarouselSliders = document.querySelectorAll('.widget-image-carousel-slider');

    $imageCarouselSliders.forEach($slider => {
        let next = $slider.parentNode.querySelector(swiperNavNextSelector);
        let prev = $slider.parentNode.querySelector(swiperNavPrevSelector);
        let pagination = $slider.parentNode.querySelector(swiperPaginationSelector);
        new Swiper($slider, {
            ...swiperConfig,
            loop: true,
            loopAddBlankSlides: false,
            slidesPerView: 1.2,
            breakpoints: {
                768: {
                    slidesPerView: 2.2,
                },
                1024: {
                    slidesPerView: 3.3,
                },
                1504: {
                    slidesPerView: 3.7,
                },
            },
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            pagination: {
                el: pagination,
                clickable: true
            }
        });
    });
});

function cloneSlides(swiper) {
    const { slidesPerView } = swiper.params;
    const totalSlides = swiper.slides.length;

    if (totalSlides < slidesPerView || slidesPerView < 3) {
        destroyClones(swiper);
        return;
    }

    if (swiper.wrapperEl.querySelector('.clone')) {
        return;
    }

    const fragment = document.createDocumentFragment();
    for (let i = 0; i < 3; i++) {
        swiper.slides.forEach(slide => {
            const $clone = slide.cloneNode(true);
            $clone.classList.add('clone');
            fragment.appendChild($clone);
        });
    }

    swiper.wrapperEl.appendChild(fragment);
    swiper.update();
}

function destroyClones(swiper) {
    const $clones = swiper.wrapperEl.querySelectorAll('.clone');

    for (const $clone of $clones) {
        $clone.remove();
    }

    swiper.update();
}
